/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TimesheetSettings
 */
export interface TimesheetSettings {
    /**
     * 
     * @type {number}
     * @memberof TimesheetSettings
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof TimesheetSettings
     */
    companyId: number;
    /**
     * 
     * @type {boolean}
     * @memberof TimesheetSettings
     */
    enableAutomaticRounding: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TimesheetSettings
     */
    roundUnscheduledTimesheets: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TimesheetSettings
     */
    roundUpTowardsStartTime: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TimesheetSettings
     */
    roundDownTowardsEndTime: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TimesheetSettings
     */
    roundUpBreaksToScheduledDuration: boolean;
    /**
     * 
     * @type {string}
     * @memberof TimesheetSettings
     */
    startTimeRoundingMode: TimesheetSettingsStartTimeRoundingModeEnum;
    /**
     * 
     * @type {number}
     * @memberof TimesheetSettings
     */
    startTimeRoundingPrecision: number;
    /**
     * 
     * @type {string}
     * @memberof TimesheetSettings
     */
    endTimeRoundingMode: TimesheetSettingsEndTimeRoundingModeEnum;
    /**
     * 
     * @type {number}
     * @memberof TimesheetSettings
     */
    endTimeRoundingPrecision: number;
    /**
     * 
     * @type {string}
     * @memberof TimesheetSettings
     */
    breakRoundingMode: TimesheetSettingsBreakRoundingModeEnum;
    /**
     * 
     * @type {number}
     * @memberof TimesheetSettings
     */
    breakRoundingPrecision: number;
    /**
     * 
     * @type {Date}
     * @memberof TimesheetSettings
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof TimesheetSettings
     */
    updatedAt: Date | null;
}

/**
* @export
* @enum {string}
*/
export enum TimesheetSettingsStartTimeRoundingModeEnum {
    NoRounding = 'No Rounding',
    RoundDown = 'Round Down',
    RoundNearest = 'Round Nearest',
    RoundUp = 'Round Up'
}
/**
* @export
* @enum {string}
*/
export enum TimesheetSettingsEndTimeRoundingModeEnum {
    NoRounding = 'No Rounding',
    RoundDown = 'Round Down',
    RoundNearest = 'Round Nearest',
    RoundUp = 'Round Up'
}
/**
* @export
* @enum {string}
*/
export enum TimesheetSettingsBreakRoundingModeEnum {
    NoRounding = 'No Rounding',
    RoundDown = 'Round Down',
    RoundNearest = 'Round Nearest',
    RoundUp = 'Round Up'
}


/**
 * Check if a given object implements the TimesheetSettings interface.
 */
export function instanceOfTimesheetSettings(value: object): value is TimesheetSettings {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('companyId' in value) || value['companyId'] === undefined) return false;
    if (!('enableAutomaticRounding' in value) || value['enableAutomaticRounding'] === undefined) return false;
    if (!('roundUnscheduledTimesheets' in value) || value['roundUnscheduledTimesheets'] === undefined) return false;
    if (!('roundUpTowardsStartTime' in value) || value['roundUpTowardsStartTime'] === undefined) return false;
    if (!('roundDownTowardsEndTime' in value) || value['roundDownTowardsEndTime'] === undefined) return false;
    if (!('roundUpBreaksToScheduledDuration' in value) || value['roundUpBreaksToScheduledDuration'] === undefined) return false;
    if (!('startTimeRoundingMode' in value) || value['startTimeRoundingMode'] === undefined) return false;
    if (!('startTimeRoundingPrecision' in value) || value['startTimeRoundingPrecision'] === undefined) return false;
    if (!('endTimeRoundingMode' in value) || value['endTimeRoundingMode'] === undefined) return false;
    if (!('endTimeRoundingPrecision' in value) || value['endTimeRoundingPrecision'] === undefined) return false;
    if (!('breakRoundingMode' in value) || value['breakRoundingMode'] === undefined) return false;
    if (!('breakRoundingPrecision' in value) || value['breakRoundingPrecision'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function TimesheetSettingsFromJSON(json: any): TimesheetSettings {
    return TimesheetSettingsFromJSONTyped(json, false);
}

export function TimesheetSettingsFromJSONTyped(json: any, ignoreDiscriminator: boolean): TimesheetSettings {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'companyId': json['companyId'],
        'enableAutomaticRounding': json['enableAutomaticRounding'],
        'roundUnscheduledTimesheets': json['roundUnscheduledTimesheets'],
        'roundUpTowardsStartTime': json['roundUpTowardsStartTime'],
        'roundDownTowardsEndTime': json['roundDownTowardsEndTime'],
        'roundUpBreaksToScheduledDuration': json['roundUpBreaksToScheduledDuration'],
        'startTimeRoundingMode': json['startTimeRoundingMode'],
        'startTimeRoundingPrecision': json['startTimeRoundingPrecision'],
        'endTimeRoundingMode': json['endTimeRoundingMode'],
        'endTimeRoundingPrecision': json['endTimeRoundingPrecision'],
        'breakRoundingMode': json['breakRoundingMode'],
        'breakRoundingPrecision': json['breakRoundingPrecision'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (json['updatedAt'] == null ? null : new Date(json['updatedAt'])),
    };
}

  export function TimesheetSettingsToJSON(json: any): TimesheetSettings {
      return TimesheetSettingsToJSONTyped(json, false);
  }

  export function TimesheetSettingsToJSONTyped(value?: TimesheetSettings | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'companyId': value['companyId'],
        'enableAutomaticRounding': value['enableAutomaticRounding'],
        'roundUnscheduledTimesheets': value['roundUnscheduledTimesheets'],
        'roundUpTowardsStartTime': value['roundUpTowardsStartTime'],
        'roundDownTowardsEndTime': value['roundDownTowardsEndTime'],
        'roundUpBreaksToScheduledDuration': value['roundUpBreaksToScheduledDuration'],
        'startTimeRoundingMode': value['startTimeRoundingMode'],
        'startTimeRoundingPrecision': value['startTimeRoundingPrecision'],
        'endTimeRoundingMode': value['endTimeRoundingMode'],
        'endTimeRoundingPrecision': value['endTimeRoundingPrecision'],
        'breakRoundingMode': value['breakRoundingMode'],
        'breakRoundingPrecision': value['breakRoundingPrecision'],
        'createdAt': ((value['createdAt']).toISOString()),
        'updatedAt': (value['updatedAt'] == null ? null : (value['updatedAt'] as any).toISOString()),
    };
}

